import React from 'react';
import { faBarcodeRead } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BarcodeReadRegularIconProps {
  className?: string;
}

function BarcodeReadRegularIcon(props: BarcodeReadRegularIconProps) {
  return <FontAwesomeIcon icon={faBarcodeRead} {...props} />;
}

export default BarcodeReadRegularIcon;
